import { useCallback, useContext, useEffect } from 'react';

import { Tabs } from '@hdi-seguros/web-components.tabs';

import {
  GenericDataFormContext,
  QUOTATION_BUTTON,
  QuotationInfoContext,
  QuotationStep,
  QuotationStepButtons,
} from '../../../../../shared';
import { FirePaymentMethods, Summary } from '../';
import { Form } from '../../../../../../../../../shared/components';

import { StepFourFormContext } from '../../contexts/StepFourForm';

import {
  generateInputID,
  getCoverageAndActivityKeyByID,
} from '../../../../../AP/Steps/StepThree/components/Quotation/utils';

import './index.css';

export const FireQuotation = () => {
  const {
    clearPrimaFieldsOnFormChange,
    labelButton,
    quotationResponse,
    setLabelButton,
    stepFourFireQuotationForm,
  } = useContext(StepFourFormContext);
  const { allCoveragesPerPlan, setFormValues } = useContext(GenericDataFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);
  const { 
    quotationTabs, 
    activeTab, 
    setActiveTab, 
    createTabs,
    handlerOnClick,
   } = useContext(StepFourFormContext);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const onPressBackButton = useCallback(async () => {
    setFormValues(stepFourFireQuotationForm.getFieldsValue());
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.THREE);
  }, [    
    quotationResponse, 
    setCurrentStep,
    setLabelButton,
    setFormValues,
    stepFourFireQuotationForm,
  ]);

  const onChangeForm = useCallback(
    (changedFields: any[]) => {
      if (quotationResponse) {
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
        clearPrimaFieldsOnFormChange();
      }

      const nameOfFieldChanged: string = changedFields[0].name[0];
      const valueChanged = changedFields[0].value;

      const { activityKey, id } =
        getCoverageAndActivityKeyByID(nameOfFieldChanged);

      const tabKey = activityKey.split('-')[2];

      const planSelected = stepFourFireQuotationForm.getFieldValue(
        `plan-tab-${tabKey}`
      );

      const allCoveragesByTab = allCoveragesPerPlan.find(
        (el) => (el.plan as string) === String(planSelected)
      )?.coverages;

      //* Verifico si la cobertura que modifique es alguna de las que dependen otras.
      const coverageCode = allCoveragesByTab?.find(
        (el) => el.id === id
      )?.codigo;

      if (coverageCode) {
        //* Tengo que verificar ahora si en las coberturas disponibles, alguna de ellas tiene relacion con este coverageCode.
        const relatedCoverages = allCoveragesByTab?.filter(
          (el) => el.codigoCoberturaRelacionada === coverageCode
        );

        //* Ahora tendría que setear en el formulario correspondiente, es decir, cada cobertura en la actividad correspondiente.
        relatedCoverages.forEach(({ porcentajeSumaAsegegurada, id }) => {
          const checkboxName = generateInputID(id, activityKey, 'checkbox');

          if (stepFourFireQuotationForm.getFieldValue(checkboxName)) {
            const inputName = generateInputID(id, activityKey);

            stepFourFireQuotationForm.setFieldValue(
              inputName,
              Math.round(
                valueChanged * (Number(porcentajeSumaAsegegurada) / 100)
              )
            );
          }
        });
      }
    },
    [
      setLabelButton,
      allCoveragesPerPlan,
      stepFourFireQuotationForm,
      quotationResponse,
      clearPrimaFieldsOnFormChange,
    ]
  );

  useEffect(() => {
    setActiveTab(1);
    createTabs();
  }, [createTabs]);
  
  return (
    <>
      <Form
        formProps={{
          form: stepFourFireQuotationForm,
          name: 'quotation-fire-tab-form',
          onFieldsChange: onChangeForm,
        }}
      >
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={quotationTabs}
        />
      </Form>

      {quotationResponse && (
        <>
          <FirePaymentMethods />

          <Summary />
        </>
      )}

      <QuotationStepButtons
        label={labelButton}
        onClick={handlerOnClick}
        onPressBackButton={onPressBackButton}
      />
    </>
  );
};
